<div style="width: 100%; display: flex;">
      <p-dropdown class="p-inputtext minContentDropdown" [options]="countryOptions" [placeholder]="placeholder"
         [(ngModel)]="selectedCountry" (ngModelChange)="onCountryCodeChange($event)" name="selectCountryCode">
      </p-dropdown>
   <input type="text" autocomplete="off" required pInputText maxlength="16" [placeholder]='placeholder'
         [(ngModel)]="phoneNumber" (ngModelChange)="onPhoneNumberChange($event)" [ngClass]="{'input-invalidNumber': invalidNumber}" />
</div>
<div *ngIf="invalidNumber" class="errorShow" style="text-align: start; margin-top: 0px !important; margin-left: 24px !important;">
   {{ invalidMessage }}
</div>
